<template>
  <div>
    <v-dialog v-model="hardwareDialog" persistent max-width="900">
      <v-card class="px-6">
        <v-card-title class="title px-4 px-4 pb-0">
          <v-layout row wrap>
            <v-flex xs6>
              <div class="font-weight-bold mt-3">Order Hardware</div>
              <br />
              <div class="font-weight-regular">
                <p>
                  Dealer: {{ selectedOrder.ubDealerID }} -
                  {{ selectedOrder.dealerFullName }}
                </p>
                <p class="my-3">
                  Order: {{ selectedOrder.orderID }} -
                  {{ selectedOrder.orderString }}
                </p>
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="ml-4 subheading">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold mt-3">Delivery Details</div>
                  </v-flex>
                  <v-flex>
                    <edit-address :orderID="selectedOrder.orderID" />
                  </v-flex>
                </v-layout>
                <div class="mt-3" v-if="deliveryDetails">
                  {{ deliveryDetails.contactName }} -
                  {{
                    deliveryDetails.contactDetails &&
                    deliveryDetails.contactDetails.companyName
                      ? deliveryDetails.contactDetails.companyName
                      : setCompanyName
                  }}
                </div>
                <p class="my-2">
                  {{ deliveryDetails ? deliveryDetails.address : '' }}
                </p>
                <div v-if="deliveryDetails.deliveryInstructions">
                  <p class="mt-3 mb-1">
                    <span>Delivery Instructions:</span>
                    <!-- <span v-if="!expanded" class="instructions">
                      {{
                        deliveryDetails.deliveryInstructions | truncate
                      }}</span
                    > -->

                    <!-- <v-btn
                      flat
                      @click="expanded = !expanded"
                      small
                      v-if="deliveryDetails.deliveryInstructions.length >= 150"
                      >see {{ expanded ? "less" : "more" }}</v-btn> -->
                  </p>
                  <div class="instructions">
                    <p>{{ deliveryDetails.deliveryInstructions }}</p>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="pb-0 px-4 mb-3">
          <!-- <ag-grid-vue
            style="height: 328px;"
            class="ag-theme-balham mb-4"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            @rowSelected="getSelectedRows()"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            suppressRowClickSelection
            rowMultiSelectWithClick
            :rowData="hardwareDetails"
            :isRowSelectable="isRowSelectable"
            pagination
            paginationAutoPageSize
          ></ag-grid-vue> -->

          <ag-grid-vue
            style="height: 328px"
            class="ag-theme-balham mb-4"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            @rowSelected="getSelectedRows()"
            @rowDataChanged="promptColumn"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            :suppressRowClickSelection="true"
            :rowData="hardwareDetails"
            :isRowSelectable="isRowSelectable"
          ></ag-grid-vue>

          <v-flex>
            <v-layout>
              <v-btn
                color="primary"
                medium
                @click="showMac()"
                :disabled="disable && !fulfilledOrders"
                class="mx-0"
              >
                Show MACs
              </v-btn>
              <v-spacer></v-spacer>
              <!-- <v-btn
                color="primary"
                medium
                @click="copyableDialog = true"
                class="btn"
                :disabled="disable"
                :class="{
                  stock: $vuetify.breakpoint.smAndDown,
                  'my-1': $vuetify.breakpoint.smAndDown,
                }"
              >Order MIA</v-btn>-->
              <v-btn
                color="primary"
                medium
                @click="orderToMia()"
                class="btn"
                :disabled="selectedRows == null || selectedRows.length == 0"
                :class="{
                  stock: $vuetify.breakpoint.smAndDown,
                  'my-1': $vuetify.breakpoint.smAndDown,
                }"
              >
                Order MIA
              </v-btn>
              <!-- <v-btn
                color="primary"
                medium
                class="btn"
                :disabled="disable"
                :class="{
                  'ms-0': $vuetify.breakpoint.smAndDown,
                  stock: $vuetify.breakpoint.smAndDown,
                  'mx-3': $vuetify.breakpoint.mdAndUp,
                }"
              >Order Elsewhere</v-btn>-->
              <v-btn
                color="primary"
                medium
                @click="orderElsewhere()"
                class="btn"
                :disabled="disable && !hasNotYetOrdered"
                :class="{
                  'ms-0': $vuetify.breakpoint.smAndDown,
                  stock: $vuetify.breakpoint.smAndDown,
                  'mx-3': $vuetify.breakpoint.mdAndUp,
                }"
              >
                Order Elsewhere
              </v-btn>
              <v-btn
                v-if="1 == 2"
                color="primary"
                medium
                :disabled="disable"
                class="btn mr-0"
              >
                Remove
              </v-btn>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="px-3 pb-3">
            <v-btn
              color="primary"
              medium
              @click="
                close();
                resetDetails();
              "
            >
              Close
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <mac-details
      :macDialog="macDialog"
      @close="macDialog = false"
    ></mac-details>
    <copyable-text
      v-if="copyableDialog"
      :copyableDialog="copyableDialog"
      :copyableData="copyableData"
      :component="'hardware'"
      @close="copyableDialog = false"
    ></copyable-text>
    <order-elsewhere
      :showOrderElsewhere="showOrderElsewhere"
      @closeOrderElsewhere="closeOrderElsewhere()"
      @saveOrder="saveOrder"
      @saved="orderProgress = false"
    ></order-elsewhere>
    <in-progress :orderProgress="orderProgress"></in-progress>
    <v-snackbar v-model="snackbar" :timeout="3000" color="red">
      {{ text }}
      <v-btn flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import MacDetails from '@/components/mia/mac-details';
import CopyableText from '@/components/mia/copyable-text';
import InProgress from '@/components/mia/in-progress';
import OrderElsewhere from '@/components/mia/order-elsewhere';
import EditAddress from './edit-address.vue';
import { AgGridVue } from 'ag-grid-vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
import { mapGetters } from 'vuex';

export default {
  name: 'HardwareDetails',
  props: {
    hardwareDialog: { type: Boolean, required: true },
  },
  filters: {
    truncate: function (text, length) {
      if (text.length > 100) {
        return text.substring(0, 100) + '...';
      } else {
        return text;
      }
    },
  },
  components: {
    MacDetails,
    CopyableText,
    AgGridVue,
    InProgress,
    OrderElsewhere,
    EditAddress,
  },
  data() {
    return {
      macDialog: false,
      orderProgress: false,
      copyableDialog: false,
      copyableData: [],
      disable: true,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      snackbar: false,
      text: '',
      showOrderElsewhere: false,
      validHardwares: [],
      selectedRows: null,
      hasNotYetOrdered: false,
      expanded: false,
    };
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Product',
        field: 'itemName',
        sortable: true,
        filter: true,
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null
            ? { opacity: '0.4' }
            : '',
      },
      {
        headerName: 'Quantity',
        field: 'quantity',
        sortable: true,
        filter: true,
        hide: true,
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null
            ? { opacity: '0.4' }
            : '',
      },
      {
        headerName: 'Quantity',
        field: 'fulfilledQuantity',
        sortable: true,
        filter: true,
        hide: true,
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null
            ? { opacity: '0.4' }
            : '',
      },
      {
        headerName: 'Stock',
        field: 'soh',
        cellRenderer: (params) =>
          params.value === null ? 'null' : params.value,
        sortable: true,
        filter: true,
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null
            ? { opacity: '0.4' }
            : '',
      },
      {
        headerName: 'Status',
        field: 'status',
        sortable: true,
        filter: true,
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null
            ? { opacity: '0.4' }
            : '',
      },
      {
        headerName: 'Select',
        field: 'select',
        checkboxSelection: true,
        headerCheckboxSelection: (params) => {
          return vm.hardwareDetails.length === vm.validHardwares.length;
        },
        cellRenderer: (params) => {
          if (params.data.soh > 0) {
            params.node.setSelected(true);
          }
        },
        cellStyle: (params) =>
          params.data.itemInternalID === 0 ||
          params.data.itemInternalID === null ||
          params.data.status === 'fullyBilled' ||
          params.data.soh <= 0
            ? { 'pointer-events': 'none', opacity: '0.4' }
            : '',
      },
    ];
    vm.defaultColDef = {
      flex: 1,
      minWidth: 100,
    };
  },
  mounted() {
    let vm = this;
    vm.resetCurrentPage();
    vm.getAllStock();
  },
  methods: {
    ...mapOrderActions([
      'resetCurrentPage',
      'resetHardwareDetails',
      'setInventoryDetails',
      'sendMIAOrder',
      'removeHardwareFromOrder',
      'orderHardwareElsewhere',
      'getOrderDetail',
      'getAllStock',
      'getDeliveryDetails',
    ]),
    ...mapOrderActions(['listOrders']),
    resetDetails() {
      let vm = this;
      vm.resetHardwareDetails();
    },
    onGridReady(params) {
      let vm = this;
      vm.gridApi = params.api;
    },
    getSelectedRows(params) {
      let vm = this;
      vm.selectedRows = vm.gridApi.getSelectedRows();
    },
    showMac() {
      let vm = this;
      vm.setInventoryDetails(vm.hardwareDetails);
      vm.macDialog = true;
    },
    orderToMia() {
      let vm = this;
      vm.orderProgress = true;

      let itemDetails = vm.gridApi.getSelectedRows();

      vm.sendMIAOrder(itemDetails)
        .then((data) => {
          if (data !== null) {
            vm.copyableData = data;
            vm.copyableDialog = true;
          }
          vm.orderProgress = false;
        })
        .catch((error) => {
          vm.orderProgress = false;
          vm.showSnackbar(error);
        });

      // setTimeout(() => {
      //   vm.orderProgress = false;
      //   vm.copyableDialog = true;
      // }, 3000)
    },
    orderElsewhere() {
      let vm = this;
      vm.showOrderElsewhere = true;
    },
    closeOrderElsewhere() {
      let vm = this;
      vm.showOrderElsewhere = false;
    },
    saveOrder(items) {
      let vm = this;
      vm.orderProgress = true;
      vm.saveOrderElsewhere(items).then((data) => {
        vm.orderProgress = false;
        vm.showSnackbar('success');
      });
    },
    showSnackbar(status) {
      let vm = this;
      vm.snackbar = true;
      vm.text = status;
    },
    close() {
      let vm = this;
      vm.selectAll = false;
      vm.gridApi.deselectAll();
      vm.$emit('close');
    },
    isRowSelectable(rowMode) {
      return rowMode.data ? !!rowMode.data.itemInternalID : false;
    },
    checkHardwareAvailability() {
      let vm = this;
      if (vm.isHardwareValid(vm.hardwareDetails)) vm.gridApi.selectAll();
      else {
        vm.gridApi.forEachNode(function (node) {
          node.setSelected(
            node.data.itemInternalID != '0' &&
              node.data.itemInternalID !== null &&
              node.data.soh >= 1
          );
        });
      }
    },
    isHardwareValid(details) {
      let result = [];
      let vm = this;
      details.forEach((x) => {
        if (
          x.itemInternalID !== '0' &&
          x.itemInternalID !== null &&
          x.soh >= 1
        ) {
          result.push('true');
          vm.validHardwares.push(x.itemName);
        } else result.push('false');
      });

      const isValid = (currentValue) => currentValue === 'true';

      if (result.every(isValid)) return true;
      else return false;
    },
    promptColumn() {
      if (this.fulfilledOrders) {
        this.gridOptions.columnApi.setColumnsVisible(
          ['fulfilledQuantity'],
          true
        );
        this.gridOptions.columnApi.setColumnsVisible(['quantity'], false);
      } else {
        this.gridOptions.columnApi.setColumnsVisible(
          ['fulfilledQuantity'],
          false
        );
        this.gridOptions.columnApi.setColumnsVisible(['quantity'], true);
      }
    },
  },
  computed: {
    ...mapGetters('orders', [
      'hardwareDetails',
      'inventoryDetails',
      'selectedOrder',
      'deliveryDetails',
    ]),
    fulfilledOrders() {
      let vm = this;
      let filter = null;
      let hasNotYetOrdered = null;
      vm.hasNotYetOrdered = false;

      if (!vm.hardwareDetails) return false;

      filter = vm.hardwareDetails.filter((row) => row.status === 'fullyBilled');
      hasNotYetOrdered = vm.hardwareDetails.filter(
        (row) => row.status === 'Not Yet Ordered'
      );

      if (hasNotYetOrdered.length > 0) vm.hasNotYetOrdered = true;
      if (filter.length > 0) return true;

      return false;
    },
    setCompanyName() {
      let vm = this;
      return vm.deliveryDetails.company
        ? vm.deliveryDetails.company.companyName
        : '';
    },
  },
  watch: {
    copyableData: function () {
      let vm = this;
      if (vm.copyableData.length > 0) vm.disable = false;
      else vm.disable = true;
    },
    hardwareDialog: function () {
      let vm = this;
      vm.checkHardwareAvailability();
    },
    selectedRows: function () {
      let vm = this;
      return vm.selectedRows;
    },
  },
};
</script>

<style>
@media (min-width: 670px) {
  .float-none {
    float: none;
  }

  .margin {
    margin: 5px 0;
  }
}
.instructions {
  max-height: 80px !important;
  height: 80px !important;
  overflow-y: auto !important;
}
</style>
